module.exports = __webpack_public_path__ + "img/主要功能-城图@2x.944aa748.png";